module.exports = __webpack_public_path__ + "img/e772a38.png";